import { Box, Button, Flex } from "@chakra-ui/react";
import { useState } from "react";
import ChatWelcome from "./ChatWelcome";
import Chat from "@/components/chat/common/Chat";
import { useChatStore } from "@/components/chat/store/chat.store";
import HeroInput from "./common/HeroInput";

const suggestedQuestions = [
  "Revisar inconsistencias en mis CFDIs del mes",
  "Verificar si un proveedor está en lista 69 o 69B",
  "Entender un requerimiento del SAT",
  "Validar complementos de pago PPD/PUE",
  "Ver la conciliación fiscal de mis RFCs",
  "¿Quieres usar esto con tus propios datos?",
];

export function SagaWorkChat() {
  const [draftQuestion, setDraftQuestion] = useState("");
  const { askQuestion, loading, messages } = useChatStore();

  const handleSubmit = async () => {
    if (!draftQuestion.trim()) return;
    await askQuestion(draftQuestion);
    setDraftQuestion("");
  };

  const handleQuestionClick = (question: string) => {
    setDraftQuestion(question);
  };

  // Filas horizontales: 3 / 2 / 2
  const row1 = suggestedQuestions.slice(0, 2);
  const row2 = suggestedQuestions.slice(2, 4);
  const row3 = suggestedQuestions.slice(4, 6);

  return (
    <Flex
      direction="column"
      align="flex-start"
      justify="space-between"
      w="100%"
      maxW="834px"
      minW={{ base: "100%", md: "700px" }}
      minH="600px"
      p={6}
      bg="white"
      borderRadius="25px"
      data-aos="fade-up"
      data-aos-anchor-placement="top-center"
    >
      <Box mb={10} textAlign={{ base: "center", md: "left" }} w="100%">
        <ChatWelcome userName="" />
      </Box>

      <Chat />

      {messages.length === 0 && (
        <Flex direction="column" gap={3} w="100%" align="flex-start">
          {/* Fila 1 */}
          <Flex
            direction={{ base: "column", md: "row" }}
            gap={3}
            w="100%"
            justify="flex-start"
          >
            {row1.map((question) => (
              <Button
                key={question}
                onClick={() => handleQuestionClick(question)}
                variant="outline"
                colorScheme="blue"
                borderRadius="full"
                fontSize="14px"
                px={6}
                py={5}
                whiteSpace="normal"
                w={{ base: "100%", md: "auto" }}
              >
                {question}
              </Button>
            ))}
          </Flex>

          {/* Fila 2 */}
          <Flex
            direction={{ base: "column", md: "row" }}
            gap={3}
            w="100%"
            justify="flex-start"
          >
            {row2.map((question) => (
              <Button
                key={question}
                onClick={() => handleQuestionClick(question)}
                variant="outline"
                colorScheme="blue"
                borderRadius="full"
                fontSize="14px"
                px={6}
                py={5}
                whiteSpace="normal"
                w={{ base: "100%", md: "auto" }}
              >
                {question}
              </Button>
            ))}
          </Flex>

          {/* Fila 3 */}
          <Flex
            direction={{ base: "column", md: "row" }}
            gap={3}
            w="100%"
            justify="flex-start"
          >
            {row3.map((question) => (
              <Button
                key={question}
                onClick={() => handleQuestionClick(question)}
                variant="outline"
                colorScheme="blue"
                borderRadius="full"
                fontSize="14px"
                px={6}
                py={5}
                whiteSpace="normal"
                w={{ base: "100%", md: "auto" }}
              >
                {question}
              </Button>
            ))}
          </Flex>
        </Flex>
      )}

      <Box w="100%" mt={6}>
        <HeroInput
          value={draftQuestion}
          onSubmit={handleSubmit}
          disabled={loading}
        />
      </Box>
    </Flex>
  );
}
